import { useState } from 'react'
import { InputAdornment } from '@mui/material'

import { SearchIcon } from '@assets/svgs/SearchIcon'
import { Loading } from '../Loading'

import type { AutocompleteProps } from './types'

import * as S from './styles'

export function Autocomplete({ placeholder, options, isLoading, onChange, onSelect }: AutocompleteProps) {
  const [open, setOpen] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [isFocused, setIsFocused] = useState(false)

  return (
    <S.Autocomplete
      freeSolo
      options={options || []}
      popupIcon={null}
      clearIcon={null}
      disableClearable={true}
      open={open && !!options?.length}
      inputValue={inputValue}
      onInputChange={(_event, newValue) => {
        setInputValue(newValue)
        onChange?.(newValue)
      }}
      onChange={onSelect}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      filterOptions={(options) => options}
      PaperComponent={({ children }) => <S.MenuPaper>{children}</S.MenuPaper>}
      renderInput={(params) => (
        <S.Input
          {...params}
          label={placeholder}
          InputLabelProps={{
            ...params.InputLabelProps,
            shrink: isFocused || Boolean(inputValue)
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">{!isLoading ? <SearchIcon /> : <Loading size="small" />}</InputAdornment>
            ),
            endAdornment: null,
            onFocus: (e) => {
              params.inputProps?.onFocus?.(e as any)
              setIsFocused(true)
            },
            onBlur: (e) => {
              params.inputProps?.onBlur?.(e as any)
              setIsFocused(false)
            }
          }}
        />
      )}
    />
  )
}
